// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  /**
   * [MK vendor-mod] Öffnet den nativen Datepicker beim Klick auf das ganze Feld
   * (nicht nur auf das Kalender-Icon). Gebunden via `on:click="/openDatePicker"`.
   * @param {Event} event
   */
  openDatePicker(event) {
    const input = /** @type {HTMLInputElement} */ (event.target);
    if (typeof input?.showPicker !== 'function') return;
    try {
      input.showPicker();
    } catch {
      // showPicker() wirft ohne User-Aktivierung oder im Cross-Origin-iframe
      // (Theme-Editor-Preview) — natives Icon-Klick-Verhalten bleibt als Fallback.
    }
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
